module.exports = __webpack_public_path__ + "static/media/eenergia.82f61e86.svg";